export default __webpack_public_path__ + "static/hero-l7-bg-29aee799e12e72379a1f45c795e56ffa.png";